import { getServices } from "../../../store/slices/subServiceSlice";
import TableComponent from "../../../components/TableComponent";
import { useNavigate } from "react-router-dom";

const AllServicesList = () => {
    const navigate = useNavigate()
    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Stock',
            dataIndex: 'stock',
            key: 'stock',
        },
    ];
    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Services</h1>
            </div>
            <TableComponent
                listData={getServices}
                columns={columns}
                placeholder="Search services..."
                onRow={(record) => ({
                    onClick: () => navigate(`/subservices`, {
                        state : {
                            title : record?.title,
                            id : record?._id,
                        }
                    }),
                    style: { cursor: 'pointer' },
                })}
                searchedData={getServices}
            />
        </div>
    )
}

export default AllServicesList